import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumb from "../common/breadcrumb";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import CKEditors from "react-ckeditor-component";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from 'react-bootstrap-button-loader';
import Tablereact from '../common/tabulator/tablereact'
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';
import Switch from '@material-ui/core/Switch'

const ComunicadosEditar = (props) => {

	const [id_comunicado] = useState(props.match.params.id);
	const [ready, setReady] = useState(false);
	const [comunicado, setComunicado] = useState({});
	const [comunicados, setComunicados] = useState([]);
	const [archivos_subidos, setArchivos_subidos] = useState([]);
	const [img_dropzone, setImg_dropzone] = useState(true);
	const [look, setLook] = useState(false);
	const [portada, setPortada] = useState([]);
	const [toggle, setToggle] = useState(false);
	const [nombre_portada, setNombre_portada] = useState('');
	const [archivos_adjuntos, setArchivos_adjuntos] = useState([]);
	const [publico, setPublico] = useState(false);
	const [estatusComunicado, setEstatusComunicado] = useState(true);

	useEffect(() => {
		fetch('/z_comunicados', {
			method: 'POST',
			body: JSON.stringify({id_comunicado}),
			headers: {'Content-Type': 'application/json'}
		})
		.then( res => res.json() )
		.then((res) => {
			console.log('Datos del comunicado:', res);
			if(res.status === 1 && res.result && res.result.length >= 1){
				var subidas=[]
				// Validar que exista res.result[1] (archivos adjuntos)
				if(res.result[1] && Array.isArray(res.result[1])){
					for(var i=0;i<res.result[1].length;i++){
						subidas.push({...res.result[1][i],subir:true})
					}
				}
				if(res.result[0] && res.result[0][0]){
					setReady(true)
					setComunicado(res.result[0][0])
					setArchivos_subidos(subidas)
					setToggle(!!res.result[0][0].PORTADA)
					setNombre_portada(res.result[0][0].PORTADA)
					setEstatusComunicado(res.result[0][0].ESTATUS_COMUNICADO)
				}else{
					console.log('ERROR: Estructura de datos incorrecta');
					toast.error("No se pudo cargar el comunicado", { position: toast.POSITION.BOTTOM_RIGHT });
				}
			}else{
				console.log('ERROR al cargar comunicado:', res);
				toast.error("Error al cargar el comunicado", { position: toast.POSITION.BOTTOM_RIGHT });
			}
		})
		.catch((err) => {
			console.log('ERROR: '+err);
			toast.error("Error de conexión", { position: toast.POSITION.BOTTOM_RIGHT });
		})

		fetch('/z_comunicados_detalles',{
			method: 'POST',
			body: JSON.stringify({id_comunicado}),
			headers: {'Content-Type': 'application/json'}
		})
		.then( res => res.json() )
		.then((res) => {
			console.log(res);
			if(res.status === 1){
				setComunicados(res.result)
			}else{console.log('ERROR')}
		})
		.catch((err) => {console.log('ERROR: '+err)})
		// eslint-disable-next-line
	}, []);

	const saveButton=()=>{
		setLook(true)
		let form_data = new FormData(document.getElementById('form_comunicados'))
		form_data.append('DESCRIPCION', comunicado.DESCRIPCION)
		form_data.append('ID', id_comunicado)
		form_data.append('archivos_subidos',JSON.stringify(archivos_subidos))
		form_data.append('portada', JSON.stringify(portada))
		form_data.append('toggle', JSON.stringify(toggle))
		form_data.append('nombre_portada', JSON.stringify(nombre_portada))
		form_data.append('estatus_comunicado', estatusComunicado)

		archivos_adjuntos.forEach((file, index) => { // Se adjuntan al form los archivos que se hayan cargado en el dropzone
			form_data.append('archivo_'+index, file)
		})

		fetch('/p_comunicados', {
			method: 'PUT',
			body: form_data
		})
		.then(res => res.json())
		.then(res => {
			console.log('Respuesta actualizar:', res);
			setLook(false)
			if(res.status === 'OK' && res.rows && res.rows[0] > 0){
				setArchivos_adjuntos([])
				toast.success("Actualizado", { position: toast.POSITION.BOTTOM_RIGHT })
				setImg_dropzone(false)
				var subidas=[]
				// Validar que exista res.result[1] (archivos adjuntos)
				if(res.result && res.result[1] && Array.isArray(res.result[1])){
					for(var i=0;i<res.result[1].length;i++){
						subidas.push({...res.result[1][i],subir:true})
					}
				}
				if(res.result && res.result[0] && res.result[0][0]){
					setComunicado(res.result[0][0])
					setArchivos_subidos(subidas)
					setToggle(!!res.result[0][0].PORTADA)
					setNombre_portada(res.result[0][0].PORTADA)
					setEstatusComunicado(res.result[0][0].ESTATUS_COMUNICADO)
					setTimeout(() => {setImg_dropzone(true)}, 100)
				}
			}else{
				console.log('No se pudo actualizar:', res);
				toast.error(res.message || "No se pudo actualizar", { position: toast.POSITION.BOTTOM_RIGHT });
			}
		})
		.catch(err => {
			setLook(false);
			console.log('Error: '+err);
			toast.error("Error de conexión", { position: toast.POSITION.BOTTOM_RIGHT });
		})
	}

	const backButton = ()=> {
		const from = props.location?.state?.from;
		if (from === 'internos') {
			props.history.push('/comunicados/publicados-internos');
		} else if (from === 'externos') {
			props.history.push('/comunicados/publicados-externos');
		} else {
			props.history.push('/comunicados/publicados');
		}
	}

	const editorData=(event)=>{
		setComunicado({...comunicado,DESCRIPCION:event.editor.getData()})
	}

	const enviar=()=>{
		if(id_comunicado){
			fetch('/z_enviar_comunicado', {
				method: 'POST',
				body: JSON.stringify({id:id_comunicado}), 
				headers: {'Content-Type': 'application/json'}
			})
			.then(res => res.json())
			.then(res => {
				if(res.status === 1 && res.rows[0] > 0){
					toast.success("Enviado", { position: toast.POSITION.BOTTOM_RIGHT })
				}
			})
			.catch(err => {console.log('Error: '+err);})
		}		
	}

	const borrar_archivo=(id)=>{
		var datos=archivos_subidos
		var index = datos.findIndex(obj => obj.ID===id);
		datos[index].subir=!datos[index].subir
		setArchivos_subidos(datos)
	}

	const changeDropzone=({ meta, file }, status)=>{
		var archivos_adjuntos_temp
		if(status === 'done'){
			archivos_adjuntos_temp=archivos_adjuntos
			archivos_adjuntos_temp.push(file)
			setArchivos_adjuntos(archivos_adjuntos_temp)
		}
		if(status === 'removed'){
			archivos_adjuntos_temp=archivos_adjuntos
			let index = archivos_adjuntos_temp.findIndex(item => item === file)
			archivos_adjuntos_temp.splice(index , 1)
			setArchivos_adjuntos(archivos_adjuntos_temp)
		}
		console.log(archivos_adjuntos);
	}

	const changeDropzonePortada=({ meta, file }, status)=>{
		if(status === 'done'){
			console.log('done')
			var reader = new FileReader();
        	reader.onloadend = function () {
				var b64 = reader.result;
				setPortada([{name:file.name,base:b64}])
        	}
        	reader.readAsDataURL(file);
		}
		if(status === 'removed'){
			console.log('removed')
			setPortada([])
		}
	}

	const cabecera = [
        { Header: <b>Nombre</b>, accessor: 'NOMBRE', style: { textAlign: 'center'}, width:'auto', editable:true , show:true},
        { Header: <b>Estatus</b>, accessor: 'NOTIFICACION', style: { textAlign: 'center'}, width:'auto', editable:true , show:true},
        { Header: <b>Descarga</b>, accessor: 'DESCARGA', style: { textAlign: 'center'}, width:'auto', editable:true , show:true}
    ];

	return (
		<Fragment>
			<Breadcrumb title="Editar comunicado" parent="Comunicados" />
			<div className="container-fluid">
				<div className="row">
					<div className="col-sm-12">
						<form id="form_comunicados" className="form theme-form">
							<div className="card">
								<div className="card-header">
									<h5>Información del comunicado</h5>
								</div>
								<div className="card-body add-post">
									{ready === false ? <h5>Cargando...</h5>:
										<div className="col-sm-12">
											<div className="email-wrapper">
											<div className="form-group">
												<label className="form-label">Portada</label>
												{
													toggle ? 
													<div className="py-5" style={{background:'#DAE0FC', borderStyle:'dashed', borderColor:'#4466F2'}}>
								                    	<p className="ml-3 h6">{comunicado.PORTADA} <i className="fa fa-times text-right" style={{cursor:'pointer', color:'#444548'}} onClick={()=>setToggle(!toggle)}></i></p>
								                	</div>
													:
													<Dropzone maxFiles={1} inputContent="Arrastre o toque para insertar imagen" inputWithFilesContent="Agregar imagen"  onChangeStatus={changeDropzonePortada} accept="image/*" />
												}
												
											</div>
                                        <p><strong>Fecha: </strong>{comunicado.FECHA_PUBLICACION}</p>
                                        <p><strong>De: </strong>{comunicado.REMITENTE}</p>
                                        <p><strong>Para: </strong>{comunicado.DESTINATARIO}</p>
                                        <p><strong>Asunto: </strong>{comunicado.ASUNTO}</p>
										<div className="form-group">
											<label htmlFor="form_titulo"><strong>Título:</strong></label>
											<input className="form-control" id="form_titulo" name="TITULO" type="text" placeholder="Título del publicación" defaultValue={comunicado.TITULO} required="" />
										</div>
										<div className="form-group">
											<label className="form-label">Estatus del Comunicado: </label>
											<Switch color="primary" onClick={()=>setEstatusComunicado(!estatusComunicado)} checked={estatusComunicado}/>
											<label className={`form-label`}>{estatusComunicado?'Visible':'Oculto'}</label>
										</div>
										<div className="form-group">
											<label className="form-label">Archivos adjuntos</label>
											{img_dropzone && <Dropzone inputContent="Toque para insertar archivos" inputWithFilesContent="Agregar archivos" onChangeStatus={changeDropzone} submitButtonContent="" accept="*" />}
										</div>
										<div className="form-group">
											<label className="form-label">Archivos subidos: {!archivos_subidos.length && 'No hay archivos subidos'}</label>
											<div className="row">
												{
													archivos_subidos.map(
														x=><div key={x.ID} className="col-4 mb-2 border-left border-right border-primary d-flex justify-content-between">
															<div>{x.ARCHIVO_RUTA}</div>
															{
																x.subir ?
																<i className="icofont icofont-trash" style={{color:'red', marginTop:'5px', cursor:'pointer'}} onClick={()=>borrar_archivo(x.ID)}></i>
																:
																<i className="icofont icofont-ui-reply" style={{color:'green', marginTop:'5px', cursor:'pointer'}} onClick={()=>borrar_archivo(x.ID)}></i>
															}
														</div>
													)
												}
												
											</div>
										</div>
										<div className="form-group">
											<label className="form-label"><strong>Mensaje del comunicado:</strong></label>
											<CKEditors
											config={{
												versionCheck: false,
												allowedContent: true,
												height: 400
											}}
											content={comunicado.DESCRIPCION}
											activeclassName="p10"
											events={{
												"change": editorData
											}}
											/>
										</div>
                                    </div>
										</div>
									}
								</div>
								<div className="card-footer">
									<div className="row">
										<div className="col-6 col-sm-6 col-lg-6">
											<button onClick={backButton} className="btn btn-light">Atrás</button>
										</div>
										<div className="col-6 col-sm-6 col-lg-6 text-right">
											<button onClick={enviar} className="btn btn-info mr-2" type="button">Enviar</button>
											<Button onClick={saveButton} className='btn btn-primary mr-1' type="button" loading={look}>Guardar</Button>
										</div>
									</div>
								</div>
							</div>
						</form>
						<div className="card">
							<div className="card-header">
								<h5>Interacción de los usuarios:</h5>
							</div>
							<div className="card-body">
							{
								comunicados.length === 0 ?
								<div className="d-flex justify-content-center align-items-center">
									<div className="loader-box mr-4">
										<div className="loader">
											<div className="line bg-warning"></div>
											<div className="line bg-warning"></div>
											<div className="line bg-warning"></div>
											<div className="line bg-warning"></div>
										</div>
									</div>
									<h5 className="text-uppercase">Cargando...</h5>
								</div>
								:
								<Tablereact
                        		    myData={comunicados}
                        		    cabecera={cabecera}
                        		    pageSize={10}
                        		    paginacion={true}
                        		    buscador='Buscar Comunicado'
                        		/>
							}
							</div>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	);
}
 
export default ComunicadosEditar;